<template>
    <div>
        <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-form @submit.prevent="save">
                <b-card>
                    <b-form-row>
                        <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                            :error="$v.form.descricao" v-model="form.descricao" label="Descrição:*" cols="12" />

                    </b-form-row>
                    <b-form-row>
                        <b-form-group label="Valor:*">
                            <b-form-input type="number" placeholder="0,00" v-model="form.valor" style="height: 20px;"
                                required></b-form-input>
                        </b-form-group>

                    </b-form-row>
                    <b-form-row>
                        <LgFormDate label="Data de Inicio:*" description='' v-model="form.dataInicio" required />
                    </b-form-row>

                    <b-form-row>
                        <LgFormDate label="Data de Fim:*" description='' v-model="form.dataFim" required />
                    </b-form-row>

                    <b-form-row>
                        <LgFinderPageTipoGarantiaContrato v-if="mostrarFinder"
                            id="finderPageTipoGarantiaContratoGarantiaForm" @close="setTipoGarantia"
                            :prefix="prefix + title + ' > '" :value="form.tipoGarantiaContrato">
                        </LgFinderPageTipoGarantiaContrato>
                    </b-form-row>

                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button v-b-tooltip.hover.top="'Salvar'" class=" my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />

                            </b-button>

                            <b-button v-b-tooltip.hover.top="'Cancelar'" class=" my-2 ml-2" size="sm" pill
                                variant="danger" @click="cancelar">
                                <b-icon icon="x-circle" />

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-card>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPageTipoGarantiaContrato from "@/components/Finders/LgFinderPageTipoGarantiaContrato.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
    components: {
        LgFormInput,
        LgFinderPageTipoGarantiaContrato,
        LgFormDate
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {
            descricao: {required},
            tipoGarantiaContrato: { id: { required } },
            dataInicio: { required },
            dataFim: { required },
            valor: { required }
        },
    },
    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            mostrarFinder: this.id == null,
            form: {
                descricao: "",
                tipoGarantiaContrato: {},
                dataInicio: "",
                dataFim: "",
                valor: 0,
            },
            showModal: true,
            title: "Cadastro",


        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/garantia-contrato`);
        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.motrarFinder = false;
            this.form = data;
            this.mostrarFinder = true;
        }

    },
    methods: {
        setTipoGarantia(item) {
            this.form.tipoGarantiaContrato = item;
        },
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }

            await this.$saveResource(this.form);
            this.cancelar();
        },

        cancelar() {
            this.$emit("close");
        },

    },
};
</script>
